
import { FETCH_PAYEMENT_CHART_FAILURE, FETCH_PAYEMENT_CHART_REMOVE, FETCH_PAYEMENT_CHART_REQUEST, FETCH_PAYEMENT_CHART_SUCCESS } from "../types/index";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

const paymentChartReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_PAYEMENT_CHART_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PAYEMENT_CHART_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_PAYEMENT_CHART_FAILURE:
      return { ...state, loading: false, error: action.error , data:[] };
    case FETCH_PAYEMENT_CHART_REMOVE:
      return { ...state, loading: false, error:null , data:[] };
    default:
      return state;
  }
};

export default paymentChartReducer;
